import { DOMAIN_LABELS } from "@/lib/sopUtils";

/**
 * Member-facing label overrides. These are applied AFTER the normal
 * domain-to-label mapping so the library, document chips, and chip links
 * all stay in sync without touching admin surfaces or DOMAIN_LABELS.
 */
const LABEL_OVERRIDES: Record<string, string> = {
  // Renames
  "The Entity Structure": "Entity Structure",
  "The Religious Covenant": "Religious Covenant",
  "Front Matter": "How This Library Works",
  "Sample Formats": "Sample Documents",
  // Merges (multiple source labels collapse into one shelf).
  // Overrides apply once (not chained), so every source label must map
  // directly to its final shelf name.
  "The Structure": "Entity Structure",
  "The Record": "Recordkeeping",
  "Records Program": "Recordkeeping",
  "Risk Response": "When Something Goes Wrong",
  "The Hard Moments": "When Something Goes Wrong",
  // Tax merge: sop TAX (DOMAIN_LABELS emits "Tax") plus two faq domains.
  "Tax": "Taxes and the IRS",
  "Filing and the IRS": "Taxes and the IRS",
  "EINs and Tax Forms": "Taxes and the IRS",
  // Finance merge: sop FIN ("Finance") plus a faq domain.
  "Money and Daily Life": "Finance",
  // People and Membership merge: sop MEM ("Membership") plus two faq domains.
  "Membership": "People and Membership",
  "People": "People and Membership",
  "Family and Workers": "People and Membership",
  // Assets merge: sop AST ("Assets") plus a faq domain.
  "Moving Assets In": "Assets",
};

/**
 * Single source of truth for member-facing section labels.
 *
 * The library groups documents by these labels, and document pages (chip)
 * show the same label so they never drift apart. Chip deep links also
 * pass this label through as `?section=...`, so any merge must be
 * expressed here rather than in a page-local map.
 *
 *  - SOP domain codes (GOV, FIN, LLC, ...) map through DOMAIN_LABELS.
 *  - FAQ domains are already stored as their display label and pass
 *    through as-is.
 *  - LABEL_OVERRIDES then renames or merges member-facing labels
 *    without changing the underlying domain codes or admin labels.
 */
export function memberDomainLabel(
  domain: string | null | undefined,
  collection: "faq" | "sop",
): string {
  const d = (domain || "").trim();
  if (!d) return "Other";

  let label: string;
  if (collection === "faq") {
    label = d;
  } else {
    label = DOMAIN_LABELS[d] || d;
  }


  return LABEL_OVERRIDES[label] || label;
}
